import React from 'react'
import { TextField } from '@material-ui/core'

export default function TextInput({ label, placeholder, type, fullWidth, value, onChangeText, onFormatValue, style }) {
    const onChange = evt => {
        const { value = '' } = evt.target
        const vlToStore = !!onFormatValue ? onFormatValue(value) : value
        !!onChangeText && onChangeText(vlToStore)
    }

    return <TextField label={label} placeholder={placeholder} type={type} fullWidth={fullWidth} value={value} onChange={onChange} style={style} />
}
